<mat-toolbar class="bg-beige-tricon">
    Applicant Information
    <button class="pl-4" mat-dialog-close>&times;</button>
</mat-toolbar>

<p>Please enter the name and email of the applicant you wish to add to this application:</p>

<form #addApplicantForm="ngForm">
    <mat-dialog-content>
        <div>
            <mat-form-field class="w-full my-2">
              <mat-label>First Name</mat-label>
              <input matInput name="FirstName" id="FirstName" required [(ngModel)]="model.FirstName" #FirstName="ngModel">
              <mat-error>Please enter a name</mat-error>
            </mat-form-field>
        </div> 
        <div>
            <mat-form-field class="w-full my-2">
              <mat-label>Last Name</mat-label>
              <input matInput name="LastName" id="LastName" required [(ngModel)]="model.LastName" #LastName="ngModel">
              <mat-error>Please enter a name</mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full my-2">
              <mat-label>Email Address</mat-label>
              <input matInput name="Email" id="Email" required email [(ngModel)]="model.Email" #Email="ngModel">
              <mat-error>Please enter a valid email address</mat-error>
            </mat-form-field>
        </div>
    
    </mat-dialog-content>
</form>
<mat-dialog-actions class="w-full flex justify-center">
    <div>
        <button mat-flat-button class="flex" color="primary" (click)="onSubmit()" [disabled]="!addApplicantForm.form.valid">SUBMIT</button>
    </div>
</mat-dialog-actions>